module.exports = __webpack_public_path__ + "img/4.31f03ea4.jpg";